
import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { Avatar, Box, Button, Card, FileButton, Flex, Text, } from '@mantine/core'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import {  Icon, } from '@flecto/ui'
import { fileToBase64, uploadImageByBase64, useCloudflareUrl } from '@flecto/utils'

import { useFormContext } from './FormProfileAccount'
import styles from './styles.module.css'

export function CardAvatar() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })

  const form = useFormContext()

  const { getUrl } = useCloudflareUrl()

  const [imgPreviewAvatar, setPreviewAvatar] = useState<string | null>(
    form.values.avatar_image_url ? getUrl(form.values.avatar_image_url) : null
  )
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false)

  const handleUploadAvatar = async (file: File | null) => {
    if (!file) {
      return
    }

    setIsUploadingAvatar(true)
    const base64 = await fileToBase64(file)
    const img = await uploadImageByBase64(base64)

    form.setFieldValue('avatar_image_id', img.id)
    setPreviewAvatar(img.urlTemporary)
    setIsUploadingAvatar(false)
  }

  const handleClearAvatar = () => {
    form.setFieldValue('avatar_image_id', null)
    form.setFieldValue('avatar_image_url', '')
    setPreviewAvatar(null)
  }

  return (
    <Card className={styles.cardAvatar} withBorder>
      <Avatar
        src={imgPreviewAvatar}
        size='xl'
        radius='50%'
        style={{ gridArea: 'avatar' }}
      >
        <Icon icon={faUser} size='xl' lh='8px' />
      </Avatar>
      <Box style={{ gridArea: 'title' }}>
        <Text fw={500}>{t('card_avatar.title')}</Text>
        <Text c='dimmed'>{t('card_avatar.description')}</Text>
      </Box>
      <Flex align='center' gap='sm' style={{ gridArea: 'buttons' }}>
        <FileButton onChange={handleUploadAvatar} accept='image/png,image/jpeg'>
          {(props) => (
            <Button
              size='sm'
              variant='outline'
              {...props}
              loading={isUploadingAvatar}
            >
              {t('card_avatar.button_change')}
            </Button>
          )}
        </FileButton>
        <Button size='sm' variant='default' onClick={() => handleClearAvatar()}>
          {t('card_avatar.button_remove')}
        </Button>
      </Flex>
    </Card>
  )
}
